<template>

    <div class="container">

        <app-head :title="product.meta_title || product.name">
            <meta name="description" :content="product.meta_description" v-if="product.meta_description">
        </app-head>

        <div class="mt-2 mt-lg-5 mb-3 d-flex justify-content-center">
            <breadcrumbs :items="breadcrumbs" />
        </div>

        <section class="mb-5 content">

            <h1 class="display-2 mb-4 text-center">{{ product.name }}</h1>
            <div v-html="product.description" class="text-center"></div>

        </section>

        <section v-if="product.contact_email">

            <div class="my-4 text-center">
                <h1>{{ __('Kontaktieren Sie uns') }}</h1>
            </div>

            <div class="row justify-content-center">
                <div class="col-md-6">

                    <template v-if="contactFormSuccess">
                        <div class="alert alert-success">
                            {{ contactFormSuccess }}
                        </div>
                    </template>
                    <form @submit.prevent="submitContactForm" v-else>
                        <text-input :floating="true" label="name" v-model="contactForm.name" :error="contactForm.errors.name" />
                        <text-input :floating="true" label="email" v-model="contactForm.email" type="email" :error="contactForm.errors.email" />
                        <text-input :floating="true" label="phone" v-model="contactForm.phone" type="tel" :error="contactForm.errors.phone" />
                        <!--<text-input :floating="true" label="subject" v-model="contactForm.subject" :error="contactForm.errors.subject" />-->
                        <textarea-input :floating="true" class-name="size-large" label="message" v-model="contactForm.message" :error="contactForm.errors.message" />
                        <submit-button label="send" :form="contactForm" />
                    </form>
                    
                </div>
            </div>

        </section>

        <section v-if="similarProducts.length">
            <heading title="Ähnliche Produkte">
            </heading>

            <product-teasers :products="similarProducts" />
        </section>

        <section>
            <heading title="Angesehene Produkte">
            </heading>
            <visited-products />
        </section>

    </div>

</template>

<style>
    .content {
        margin: 0 auto;
        max-width: 1100px;
    }
    .content h1 {
        margin: 1rem 0 2rem;
    }
    .content h2 {
        margin: 2rem 0 2rem;
        font-weight: 300;
    }
    .content h3 {
        margin: 2rem 0 2rem;
        font-weight: 300;
    }
    .content h4 {
        margin: 2rem 0 2rem;
        font-weight: 700;
    }
    .content h5 {
        margin: 2rem 0 2rem;
        font-weight: 700;
    }
    .content h6 {
        margin: 2rem 0 2rem;
        font-weight: 700;
    }
    .content p {
        line-height: 2.0;
        margin: 0 0 1rem;
    }
    .content ul, .content ol {
        /*text-align: left;*/
        line-height: 2.0;
        list-style: none;
        margin: 2rem 0 2rem;
    }
    .content li {
        position: relative;
    }
    .content ul li::before {
        font-family: 'bootstrap-icons';
        content: "\f26c";
        color: #f59c00;
        position: absolute;
        transform: translateX(-150%);
    }
    .content img {
        max-width: 100%;
        height: auto;
        display: block;
        margin: 2rem auto;
    }
</style>

<script>
    import Heading from '@/shared/Heading';
    import Breadcrumbs from '@/shared/Breadcrumbs';
    import VisitedProducts from '@/shared/VisitedProducts';
    import ProductTeasers from '@/shared/ProductTeasers';

    import TextInput from '@/shared/Inputs/TextInput';
    import TextareaInput from '@/shared/Inputs/TextareaInput';
    import SubmitButton from '@/shared/Inputs/SubmitButton';

    export default {
        props: [
            'product',
            'currentPropertyOptions',
            'images',
            'documents',
            'offers',
            'lowestPrice',
            'similarProducts',
            'isOnWatchlist',
            'customerMustHaveRelation',
            'customerMustHaveRelationUrl',
            'customerHasRelation',
            'documentDefaultContent',
            'contactFormSuccess',
        ],
        mounted() {
        },
        data() {
            return {
                contactForm: this.$inertia.form({
                    name: this.$page.props.auth.user.full_name || null,
                    email: this.$page.props.auth.user.email || null,
                    phone: null,
//                    subject: null,
                    message: null,
                }),
            }
        },
        components: {
            Heading,
            Breadcrumbs,
            VisitedProducts,
            ProductTeasers,
            TextInput,
            TextareaInput,
            SubmitButton,
        },
        computed: {
            breadcrumbs() {
                var items = [{url: this.route('categories.index'), label: this.__('Categories')}];
                if (this.product.main_category) {
                    items.push({url: this.route('categories.show', this.product.main_category.path), label: this.product.main_category.name});
                }

                return items;
            }
        },
        watch: {
        },
        methods: {
            submitContactForm() {
                this.contactForm.post(route('products.submit-contact-form', this.product), {
                    preserveScroll: true,
                    onSuccess: () => this.contactForm.reset(),
                })
            }
        }
    }
</script>